import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton } from '@mui/material';
import CustomTooltip from '../../atoms/CustomTooltip';
import { useIsTabletOrMobile } from '../../../../hooks/useIsTabletOrMobile';

const ToggleSatelliteButton = ({
  isSattelite,
  changeMap,
  isLoadingMap,
  isSmall,
}) => {
  const { t } = useTranslation();
  const isTabletOrMobile = useIsTabletOrMobile();

  return (
    <CustomTooltip
      title={t('tools_menu.view', {
        message_type: isSattelite ? 'road' : 'satellite',
      })}
      arrow
      placement="left"
    >
      <Box
        sx={{
          position:
            isTabletOrMobile && !isSmall ? 'inherited' : 'absolute !important',
          bottom: isSmall ? '7rem' : '8.5rem',
          zIndex: 3,
          right: ' 0.6rem',
          background: '#fff',
          borderRadius: '0.25rem',
          width: isSmall ? '30px' : '40px',
          height: isSmall ? '30px' : '40px',

          i: {
            margin: 0,
            padding: 0,
            width: isSmall ? '14px' : '24px',
            height: isSmall ? '14px' : '24px',
          },
        }}
      >
        <IconButton
          data-tip=""
          data-for="roadView"
          type="button"
          onClick={changeMap}
          disabled={isLoadingMap}
        >
          <i
            style={{ fontSize: isSmall ? '14px' : '20px', color: '#383838' }}
            className={`fas ${isSattelite ? 'fa-road' : 'fa-satellite-dish'}`}
          />
        </IconButton>
      </Box>
    </CustomTooltip>
  );
};

ToggleSatelliteButton.propTypes = {
  changeMap: PropTypes.func.isRequired,
  isLoadingMap: PropTypes.bool.isRequired,
  isSattelite: PropTypes.bool.isRequired,
  isSmall: PropTypes.bool,
};

export default ToggleSatelliteButton;
